<template>
  <v-container>
    <div class="text-h4 mb-6">
      {{ __("Envio de link por SMS") }}
    </div>

    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-card :loading="loading">
        <v-card-title>
          {{ __("Enviar link") }}
        </v-card-title>

        <v-divider />

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <ValidationProvider
                name="automation.insurer"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="form.insurer_id"
                  :items="insurers"
                  item-text="name"
                  item-value="id"
                  :label="__('Companhia')"
                  prepend-icon="mdi-domain"
                  :error-messages="errors"
                  outlined
                  clearable
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="6">
              <ValidationProvider
                name="automation.phone"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.phone"
                  :label="__('Telefone', 'contact')"
                  prepend-icon="mdi-phone"
                  :error-messages="errors"
                  outlined
                  clearable
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            :loading="loading"
            :disabled="invalid || loading"
            @click="confirmSend"
          >
            {{ __("Enviar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>

    <ConfirmationDialog ref="confirmDialog" />
  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import i18n from "@/mixins/i18n";
import ToastsMixin from "@/mixins/ToastsMixin.vue";

import { index as indexInsurers } from "@/services/insurers";
import { sendLinkFnolViaSMS } from "@/services/fnol/fnol";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    ConfirmationDialog,
  },

  mixins: [i18n, ToastsMixin],

  data() {
    return {
      i18n_prefix: "sms",

      loading: false,

      insurers: [],

      form: {
        insurer_id: null,
        phone: "",
      },
    };
  },

  async mounted() {
    await this.loadInsurers();
  },

  methods: {
    async loadInsurers() {
      this.loading = true;

      try {
        const response = await indexInsurers();
        this.insurers = response;
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form.insurer_id = null;
      this.form.phone = "";

      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },

    buildDescription() {
      const insurer = this.insurers.find((i) => i.id === this.form.insurer_id);

      return `
        ${this.__("Será enviado um link por SMS para")}
        <strong>${this.form.phone}</strong>
        ${this.__("utilizando a configuração da companhia")}
        <strong>${insurer?.name}</strong>.
      `;
    },

    async confirmSend() {
      const valid = await this.$refs.observer.validate();

      if (!valid) {
        return;
      }

      this.$refs.confirmDialog.confirm(
        this.__("Confirmar envio de link por SMS"),

        async ({ close, startLoading, stopLoading }) => {
          startLoading();
          this.loading = true;

          try {
            const payload = {
              insurer_id: this.form.insurer_id,
              phone: this.form.phone,
            };

            const response = await sendLinkFnolViaSMS(payload);

            this.toastSuccess(response.message);

            this.resetForm();

            close();
          } catch (error) {
            this.toastError(
              error?.response?.message || this.__("Erro ao enviar SMS.")
            );
          } finally {
            this.loading = false;
            stopLoading();
          }
        },

        null,

        {
          description: this.buildDescription(),
          confirmText: this.__("confirmar"),
          cancelText: this.__("cancelar"),
          color: "primary",
        }
      );
    },
  },
};
</script>
